import { IAppState } from '../../common/state';

export function selectCrossLinks({ seoCrossLinks }: IAppState) {
  return seoCrossLinks;
}
